module.exports = __webpack_public_path__ + "img/for_education.56680748.png";